/**
 * Normaliza texto eliminando tildes, convirtiendo a mayúsculas y reemplazando espacios por "_".
 */
export const normalizarTexto = (texto) => {
    if (!texto) return "";
    return texto
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase()
        .trim()
        .replace(/\s/g, "_")
        .replace(/[^\w\s]/gi, "");
};

/**
 * Genera el nombre del archivo APU.
 * Soporta tanto los atributos de la capa 0 (nombredepartamento, nombreprovincia, codigoprovincia)
 * como de tablas relacionadas (nom_dpto, nom_provincia, cod_provincia).
 */
export const generarNombreArchivo = (provinciaInfo, year, semester) => {
    if (!provinciaInfo) return "";
    const nomDpto = provinciaInfo.nom_dpto || provinciaInfo.nombredepartamento || "";
    const nomProv = provinciaInfo.nom_provincia || provinciaInfo.nombreprovincia || "";
    const codProv = provinciaInfo.cod_provincia || provinciaInfo.codigoprovincia || "";
    const depto = normalizarTexto(nomDpto);
    const provincia = normalizarTexto(nomProv);
    return `APU_${codProv}_${depto}__${provincia}_${year}_${semester}.xlsx`;
};

/**
 * Genera la URL completa al archivo.
 */
export const generarUrlArchivo = (provinciaInfo, year, semester) => {
    const nombreArchivo = generarNombreArchivo(provinciaInfo, year, semester);
    return (
        process.env.REACT_APP_HERMES2_URL +
        process.env.REACT_APP_FOLDER_PROVINCIAS_URL +
        `${year}_${semester}/${nombreArchivo}`
    );
};

/**
 * Verifica si un archivo existe mediante una solicitud HEAD.
 * Retorna: true si existe, false si no.
 */
export const verificarArchivoExiste = async (url) => {
    try {
        const response = await fetch(url, { method: "HEAD" });
        return response.status !== 404 && response.ok;
    } catch (error) {
        console.error("Error verificando archivo:", error);
        return false;
    }
};
